<template>
  <div></div>
</template>
<script>
import { ON_CLICK_CELL, ON_DISPLAY_BAND } from '@/common/resources/const'
import { apiRequest } from '@/common/utils/request'
import _ from 'lodash'
import { eventBodyListParser } from '@/common/utils/gnb.fp'

export default {
  name: 'EventProcessor',
  data () {
    return {
      onDisplayEventList: [],
      onClickEventList: [],
      onDisplayTimer: null,
      onClickTimer: null
    }
  },
  methods: {
    deepCopy (list) {
      return _.map(list, _.clone)
    },
    flushOnDisplay () {
      if (this.onDisplayEventList.length === 0) {
        clearTimeout(this.onDisplayTimer)
        return
      }
      const copyList = this.deepCopy(this.onDisplayEventList)
      this.onDisplayEventList = []
      this.sendEventLogList(copyList)
    },
    flushOnClick () {
      if (this.onClickEventList.length === 0) {
        clearTimeout(this.onClickEventList)
        return
      }
      const copyList = this.deepCopy(this.onClickEventList)
      this.onClickEventList = []
      this.sendEventLogList(copyList)
    },
    addOnDisplayEvent (event) {
      this.onDisplayEventList.push(event)
    },
    addOnClickEvent (event) {
      this.onClickEventList.push(event)
    },
    sendEventLogList (list) {
      if (list.length === 0) return
      const eventInfo = _.first(list)
      return apiRequest({
        url: 'https://' + _.get(eventInfo, 'url'),
        method: _.get(eventInfo, 'method'),
        headers: { 'Content-Type': 'text/html; charset=utf-8' },
        data: {
          list: list.map(eventBodyListParser)
        }
      })
    }
  },
  mounted () {
    this.$events.$on(ON_DISPLAY_BAND, event => {
      this.addOnDisplayEvent(event)
    })
    this.$events.$on(ON_CLICK_CELL, event => {
      this.addOnClickEvent(event)
    })
  },
  watch: {
    onDisplayEventList () {
      clearTimeout(this.onDisplayTimer)
      this.onDisplayTimer = setTimeout(() => {
        this.flushOnDisplay()
      }, 2000)
    },
    onClickEventList () {
      clearTimeout(this.onClickTimer)
      this.onClickTimer = setTimeout(() => {
        this.flushOnClick()
      }, 5000)
    }
  }
}
</script>
<style scoped>

</style>
